import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { SignalRConnection } from 'ng2-signalr';
import { UserPreference } from '../../models/UserPreference';
import { errorMessages } from '../../settings';
import { CommonService } from '../common.service';
import { DashboardService } from '../dashboard.service';
import { WidgethelperService } from '../widgethelper.service';
import { BaseService } from './base.service';


@Injectable()
export class OpenpickstasksService extends BaseService {

  constructor(private _dashboardService: DashboardService,
    private _widgetHelper: WidgethelperService,
    private _commonService: CommonService) {
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor('broadcastOpenDailyTasks')
    .subscribe((result: any) => {
      console.log('broadcastOpenDailyTasks', result);
      let resultwid;
      let resultcreationtime;
      let lastUpdatedTime;

      if (result && result.length > 0) {
        //console.log(result[0].IsNoDataFound);
        widget.IfNoDataFound = result[0].IsNoDataFound;
        resultwid = result[0].widgetid;
        resultcreationtime = result[0].widgetcreationtime;
        lastUpdatedTime = result[0].LastUpdateTime;
      }
      else {
        widget.errorMessage = errorMessages.noWidgetData;
      }


      if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
        widget.dataLoaded = false;
        widget.chartOptions = this.chartOptions();
        widget.errorMessage = null;
        //need to format this 
        let series = [];
        let xaxis = [];

        result.forEach(el => {
          series.push([el.GroupByName, el.GroupByCount]);
          xaxis.push(el.GroupByName);
        });

        if (widget.IfNoDataFound) {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        else {
          widget.errorMessage = null;
        }
        this.addDataSeries(widget.chartOptions, series, 'Open Pick Tasks', 'bar');
        this.addZoomBar(widget.chartOptions);
        widget.chartOptions.grid.bottom = '6%';
        widget.chartOptions.grid.left = '6%';
        widget.chartOptions.xAxis.axisLabel.rotate = 45;
        widget.chartOptions.xAxis.data = xaxis;
      }
      widget.dataLoaded = true;
      this._commonService.lastUpdatedTime = lastUpdatedTime;
    }
      , err => {
        console.log('listenFor broadcastOpenDailyTasks error', err);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/services/widgets/openpickstasks.service.ts